import React from "react";

//Question
import AnswerItemRadio from "./AnswerItemRadio";

function QuestionSelectOne(props) {
    return (
        <div className="answerList" >
            <AnswerItemRadio
                {...props}
            />
        </div>
    );
}

export default QuestionSelectOne;